// Turkish (Turkey) translation overlay for Flight 67 passenger data.
// Unchanged proper nouns and non-descriptive data are inherited from the source.

export const passengerDataTrTR = {
	'1A': {
		height: '5 fit 4 inç',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Buzlu latte' }, { item: 'Çalışma rehberi' }, { item: 'Telefon şarj cihazı' }],
		texts: ['Bahar tatilini iple çekiyorum!', 'Ödevini bitirdin mi?', 'Annem selam söylüyor'],
	},
	'1B': {
		height: '5 fit 5 inç',
		eyes: 'Kahverengi',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Güneş gözlüğü' }, { item: 'Moka' }, { item: 'Dergi' }],
		texts: ['Uçuş zamanında!', 'Bagaj alım alanında görüşürüz', 'Seni seviyorum, anne'],
	},
	'1C': {
		height: '5 fit 6 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Ders kitabı' }, { item: 'Kapuçino' }, { item: 'Boyun yastığı' }],
		texts: ['Yurt odası hazır', 'Oryantasyon pazartesi günü', 'Şimdiden özledim!'],
	},
	'1D': {
		height: '5 fit 10 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Seyahat battaniyesi' }, { item: '32 oz su şişesi' }, { item: 'Sandviç' }],
		texts: ['Biniş kapısına gecikiyorum', 'Bana bir yer ayır', 'Bu havaalanı devasa'],
	},

	'2A': {
		height: '5 fit 3 inç',
		eyes: 'Kahverengi',
		hair: 'Pembeye boyanmış',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Kulak içi kulaklık' }, { item: 'Roman' }, { item: 'Yeşil çay' }],
		texts: ['Neredeyse geldim!', 'Atıştırmalıkları koydun mu?', 'B12 kapısıydı, değil mi?'],
	},
	'2B': {
		height: '5 fit 11 inç',
		eyes: 'Mavi',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Sırt çantası' }, { item: 'Americano' }, { item: 'Kuruyemiş karışımı' }],
		texts: ['Gelecek ay snowboard gezisi?', 'Uçuş 30 dakika gecikti', 'Kahve almaya gidiyorum'],
	},
	'2C': {
		height: '5 fit 5 inç',
		eyes: 'Mavi',
		hair: 'Turkuaza boyanmış',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Günlük' }, { item: 'Smoothie' }, { item: 'Uyku maskesi' }],
		texts: ['İşler bitti', 'Sonunda tatildeyim!', 'Yakında görüşürüz!'],
	},
	'2D': {
		height: '6 fit',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Switch oyunu' }, { item: 'Bir dilim pizza' }, { item: 'USB kablosu' }],
		texts: ['Havaalanında çok sıkıldım', 'O oyunu indirdin mi?', '2 saatlik aktarma, öff'],
	},

	'3A': {
		height: '5 fit 7 inç',
		eyes: 'Mavi',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Hukuk dergisi' }, { item: 'Duble espresso' }, { item: 'Atkı' }],
		texts: ['Dilekçe verildi', 'Mülakat harika geçti', 'Bu gece kutluyoruz!'],
	},
	'3B': {
		height: '6 fit 1 inç',
		eyes: 'Yeşil',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Basketbol topu' }, { item: 'Kombo menü' }, { item: 'Sakız' }],
		texts: ['Maç bu akşam 8’de', 'Beni alır mısın?', 'Yarın basket atalım'],
	},
	'3C': {
		height: '5 fit 4 inç',
		eyes: 'Kahverengi',
		hair: 'Kızıl',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Gitar telleri' }, { item: 'Plak' }, { item: 'Chai latte' }],
		texts: ['Konser muhteşemdi!', 'Yeni şarkı yakında çıkıyor', 'Stüdyo saati ayarlandı'],
	},
	'3D': {
		height: '5 fit 9 inç',
		eyes: 'Mavi',
		hair: 'Kızıl',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Sörf tahtası mumu' }, { item: 'Burrito' }, { item: 'Parmak arası terlik' }],
		texts: ['Bugün dalgalar müthiş', 'Saat 6’da sahile?', 'Sörf yarışması gelecek hafta'],
	},

	'4A': {
		height: '5 fit 6 inç',
		eyes: 'Yeşil',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Sağlık çalışanı forması' }, { item: 'Salata' }, { item: 'Tıp dergisi' }],
		texts: ['Vardiya 7’de başlıyor', 'Hasta daha iyi', 'Sonunda izin günü!'],
	},
	'4B': {
		height: '5 fit 10 inç',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Dizüstü bilgisayar standı' }, { item: 'Soğuk demleme kahve' }, { item: 'Protein barı' }],
		texts: ['Kod yayına alındı', 'Toplantı saat 3’te', 'Bugün uzaktan çalışıyorum'],
	},
	'4C': {
		height: '5 fit 8 inç',
		eyes: 'Ela',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Makyaj seti' }, { item: 'Cupcake' }, { item: 'Elbise' }],
		texts: ['İçerik hazır', 'Yarın ortak çalışma var!', 'Yeni filtreye bayıldım'],
	},
	'4D': {
		height: '6 fit 2 inç',
		eyes: 'Kahverengi',
		hair: 'Kızıl',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Lens filtresi' }, { item: 'Red Eye kahvesi' }, { item: 'Eskiz defteri' }],
		texts: ['Çekim sonu partisi bu gece', 'Senaryo iyi görünüyor', 'Çağrı saati sabah 5'],
	},

	'5A': {
		height: '5 fit 5 inç',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Ajanda' }, { item: 'Açaí kasesi' }, { item: 'Bagaj etiketi' }],
		texts: ['Kampanya başladı!', 'Rakamlar harika görünüyor', 'Müşteri bayıldı'],
	},
	'5B': {
		height: '5 fit 11 inç',
		eyes: 'Yeşil',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Üyelik' }, { item: 'Protein içeceği' }, { item: 'Koşu ayakkabısı' }],
		texts: ['Deadliftte kişisel rekor!', 'Yarın bacak günü', 'Diyet pazartesi başlıyor'],
	},
	'5C': {
		height: '5 fit 7 inç',
		eyes: 'Mavi',
		hair: 'Kızıl',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Araba kullanım kılavuzu' }, { item: 'Kahvaltı' }, { item: 'Kol saati' }],
		texts: ['Araba tamir edildi!', 'Ekiple buluşuyorum', 'Detroit gururu!'],
	},
	'5D': {
		height: '6 fit',
		eyes: 'Mavi',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Yatırım rehberi' }, { item: 'Flat white' }, { item: 'Kravat' }],
		texts: ['Piyasalar yükselişte', 'Anlaşma tamam!', 'Prim geliyor'],
	},

	'6A': {
		height: '5 fit 4 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [
			{ item: 'Yeniden kullanılabilir çantalar' },
			{ item: 'Vegan dürüm' },
			{ item: 'Sürdürülebilirlik kitabı' },
		],
		texts: ['Bağış kampanyası başarılı oldu!', 'Cumartesi sahil temizliği var', 'Gezegeni kurtarıyoruz'],
	},
	'6B': {
		height: '5 fit 10 inç',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Matkap uçları' }, { item: 'Büyük pizza' }, { item: 'Boya' }],
		texts: ['Proje bitti!', 'Daha fazla çivi lazım', 'Ev harika görünüyor'],
	},
	'6C': {
		height: '5 fit 6 inç',
		eyes: 'Yeşil',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Dekorasyon seti' }, { item: 'Blazer ceket' }, { item: 'Buzlu kahve' }],
		texts: ['Ev satıldı!', 'Saat 2’de gösterim var', 'Komisyon geliyor'],
	},
	'6D': {
		height: '6 fit 1 inç',
		eyes: 'Mavi',
		hair: 'Kahverengi',
		passport: 'Arjantin',
		purchases: [{ item: 'Sos seti' }, { item: 'Antrikot yemeği' }, { item: 'Chiefs forması' }],
		texts: ['Chiefs krallığı!', 'Bu hafta sonu barbekü?', 'Maç gününe hazırım'],
	},

	'7A': {
		height: '5 fit 5 inç',
		eyes: 'Kahverengi',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Sınıf dekorasyonu' }, { item: 'Bitki çayı' }, { item: 'Çocuk kitapları' }],
		texts: ['Çocuklar derse bayıldı', 'Yarın veli görüşmesi var', 'Yaz tatili yaklaşıyor!'],
	},
	'7B': {
		height: '5 fit 9 inç',
		eyes: 'Yeşil',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Stetoskop' }, { item: 'Protein kasesi' }, { item: 'Tıp kitabı' }],
		texts: ['12 saatlik vardiya bitti', 'Bugün bir hayat kurtardım', 'Acilen kahve lazım'],
	},
	'7C': {
		height: '5 fit 8 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Yoga matı' }, { item: 'Yeşil meyve suyu' }, { item: 'Tayt' }],
		texts: ['Herkese namaste!', 'Ders sabah 6’da', 'Bugün içim çok huzurlu'],
	},
	'7D': {
		height: '6 fit',
		eyes: 'Kahverengi',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Eldiven' }, { item: 'Yakıt' }, { item: 'Enerji içeceği' }],
		texts: ['Yarın piste çıkıyorum', 'Yeni tur rekoru!', 'Yarış gününe hazırım'],
	},

	'8A': {
		height: '5 fit 4 inç',
		eyes: 'Ela',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Kumaş numuneleri' }, { item: 'Makaron' }, { item: 'Vintage broş' }],
		texts: ['Tasarım onaylandı!', 'Müşteri toplantısı harika geçti', 'Bu estetiğe bayıldım'],
	},
	'8B': {
		height: '5 fit 11 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Kolombiya',
		purchases: [{ item: 'Doğa yürüyüşü botları' }, { item: 'Malzemeler' }, { item: 'Çadır kazıkları' }],
		texts: ['Zirveye ulaştım!', 'Patika çok güzeldi', 'Sıradaki dağ: Rainier'],
	},
	'8C': {
		height: '5 fit 6 inç',
		eyes: 'Yeşil',
		hair: 'Kızıl',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Şerbetçi otu' }, { item: 'Yerel bal' }, { item: 'Mason kavanozları' }],
		texts: ['Yeni IPA hazır!', 'Tadım salonu tıklım tıklım', 'Herkese şerefe!'],
	},
	'8D': {
		height: '6 fit 2 inç',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Gitar penası seti' }, { item: 'Didiklenmiş domuz eti' }, { item: 'BB King albümü' }],
		texts: ['Bu gece Beale Street', 'Saat 9’da blues jam var', 'Müzik hayattır'],
	},

	'9A': {
		height: '5 fit 5 inç',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Bıçak seti' }, { item: 'Cajun baharat karışımı' }, { item: 'Taze kerevit' }],
		texts: ['Mutfak hazır!', 'Yeni menü yakında geliyor', 'Eğlence devam etsin!'],
	},
	'9B': {
		height: '5 fit 10 inç',
		eyes: 'Mavi',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Taşınabilir monitör' }, { item: 'Pour-over kahve' }, { item: 'Günlük giriş kartı' }],
		texts: ['Finansman tamam!', 'Sunum harika geçti', 'Girişimci hayatı'],
	},
	'9C': {
		height: '5 fit 7 inç',
		eyes: 'Ela',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Evrak çantası' }, { item: 'Tahıl kasesi' }, { item: 'Finans kitabı' }],
		texts: ['Portföy %12 yükseldi', 'Bu gece müşteriyle yemek var', 'Üç aylık değerlendirme bitti'],
	},
	'9D': {
		height: '6 fit 1 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Telesiyej bileti' }, { item: 'Kayak gözlüğü' }, { item: 'El ısıtıcıları' }],
		texts: ['Toz kar günü!', 'Siyah elmas pisti', 'Hayallerimi yaşıyorum'],
	},

	'10A': {
		height: '5 fit 4 inç',
		eyes: 'Mavi',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Bebek bezi' }, { item: 'Bebek maması' }, { item: 'Pelüş oyuncak' }],
		texts: ['Bebeğin ilk uçuşu!', 'Bebek bezi çantasını hazırla', 'Az kaldı, büyükanne!'],
	},
	'10B': {
		height: '5 fit 9 inç',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Nikaragua',
		purchases: [{ item: 'Poker fişleri' }, { item: 'Fileminyon' }, { item: 'Güneş gözlüğü' }],
		texts: ['Büyük ikramiyeyi kazandım!', 'Encore’da havuz partisi', 'Vegas’ta olan Vegas’ta kalır...'],
	},
	'10C': {
		height: '5 fit 6 inç',
		eyes: 'Mavi',
		hair: 'Kızıl',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Vaka incelemeleri' }, { item: 'Earl Grey çayı' }, { item: 'İnci küpeler' }],
		texts: ['Dava düştü!', 'İfade yarın', 'Adalet yerini buldu'],
	},
	'10D': {
		height: '6 fit',
		eyes: 'Mavi',
		hair: 'Gri',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Akıllı saat' }, { item: 'Nitro soğuk demleme kahve' }, { item: 'Yapay zekâ kitabı' }],
		texts: ['Halka arz gelecek çeyrekte', 'Yönetim kurulu toplantısı saat 4’te', 'Satın alma görüşmeleri'],
	},

	'11A': {
		height: '5 fit 5 inç',
		eyes: 'Ela',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Köpek ödül mamaları' }, { item: 'Avokadolu tost' }, { item: 'Hırka' }],
		texts: ['Köpeğimi şimdiden özledim', 'Ev bakıcısı harika', 'Tatil modu AÇIK'],
	},
	'11B': {
		height: '5 fit 7 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Tansiyon ölçüm seti' }, { item: 'Tavuklu salata' }, { item: 'Sağlıklı yaşam rehberi' }],
		texts: ['Hasta iyileşti!', 'Klinik yakında açılıyor', 'Sağlık en büyük zenginliktir'],
	},
	'11C': {
		height: '5 fit 11 inç',
		eyes: 'Yeşil',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Bira yapım seti' }, { item: 'Olgunlaştırılmış çedar' }, { item: 'Packers şapkası' }],
		texts: ['Haydi Packers!', 'Cumartesi bira fabrikası turu', 'Peynir telemeleri candır'],
	},
	'11D': {
		height: '6 fit',
		eyes: 'Kahverengi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Hesap makinesi' }, { item: 'Yeşil acı biberli hamburger' }, { item: 'Mühendislik kılavuzu' }],
		texts: ['Köprü tasarımı onaylandı', 'Saha denetimi tamamlandı', 'Proje plana uygun ilerliyor'],
	},

	'12A': {
		height: '5 fit 6 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Dosyalar' }, { item: 'Kulüp sandviç' }, { item: 'Bluz' }],
		texts: ['Poliçe yenilendi', 'Toplantı 3’e alındı', 'Harika bir çeyrek!'],
	},
	'12B': {
		height: '5 fit 4 inç',
		eyes: 'Ela',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Vintage vazo' }, { item: 'Scone seti' }, { item: 'Tarih kitabı' }],
		texts: ['Bir hazine buldum!', 'Yarın tereke satışı var', 'Bu antikaya bayıldım'],
	},
	'12C': {
		height: '5 fit 10 inç',
		eyes: 'Mavi',
		hair: 'Siyah',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'İş botları' }, { item: 'Kahvaltılık burrito' }, { item: 'El feneri' }],
		texts: ['Vardiya 6’da bitiyor', 'Yeni bir damar keşfedildi', 'Güvenlik her zaman önce gelir'],
	},
	'12D': {
		height: '6 fit 1 inç',
		eyes: 'Kahverengi',
		hair: 'Beyaz',
		passport: 'Birleşik Arap Emirlikleri',
		purchases: [{ item: 'Steelers forması' }, { item: 'Pierogi tabağı' }, { item: 'Kaynak maskesi' }],
		texts: ['Haydi Steelers!', 'Tesis sorunsuz çalışıyor', 'Pazar günü aile yemeği'],
	},

	'13B': {
		height: '5 fit 11 inç',
		eyes: 'Mavi',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Sade kahve' }, { item: 'Gizem romanı' }, { item: 'Taşınabilir şarj cihazı' }],
		texts: [
			'Biraz su ister misin?',
			'Ne çılgın bir uçuş. Dostum, gerçekten tuvalete gitmem lazım!',
			'Haberin son teslim tarihi yarın',
		],
	},
	'13C': {
		height: '5 fit 5 inç',
		eyes: 'Yeşil',
		hair: 'Sarı',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Mickey kulakları' }, { item: 'Hindi budu' }, { item: 'Fotoğraf albümü' }],
		texts: ['Çocuklar çok eğlendi!', 'Büyülü bir tatil', 'Yakında evimize dönüyoruz'],
	},
	'13D': {
		height: '5 fit 9 inç',
		eyes: 'Yeşil',
		hair: 'Gri',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Hesap makinesi' }, { item: 'Filtre kahve' }, { item: 'Vergi rehberi' }],
		texts: ['Vergi sezonu yoğunluğu', 'Beyannameler verildi!', 'Denetim tamamlandı'],
	},

	'14A': {
		height: '5 fit 4 inç',
		eyes: 'Mavi',
		hair: 'Gri',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Çiçek tohumları' }, { item: 'Papatya çayı' }, { item: 'Örgü şişleri' }],
		texts: ['Bahçe çiçek açıyor!', 'Torunlar ziyarete geliyor', 'Taptaze kurabiye yaptım'],
	},
	'14B': {
		height: '6 fit',
		eyes: 'Kahverengi',
		hair: 'Gri',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Mızıka' }, { item: 'Dana döş tabağı' }, { item: 'Johnny Cash albümü' }],
		texts: ['Opry muhteşemdi!', 'Gelecek hafta kayıt var', 'Country müzik sonsuza dek!'],
	},
	'14C': {
		height: '5 fit 5 inç',
		eyes: 'Ela',
		hair: 'Kahverengi',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'At ödül mamaları' }, { item: 'Hot Brown' }, { item: 'At bakımı rehberi' }],
		texts: ['Derbi sezonu!', 'At bugün kazandı!', 'Bluegrass benim evim'],
	},
	'14D': {
		height: '5 fit 6 inç',
		eyes: 'Kahverengi',
		hair: 'Gri',
		passport: 'Amerika Birleşik Devletleri',
		purchases: [{ item: 'Halat' }, { item: 'Yengeç köftesi' }, { item: 'Pusula' }],
		texts: ['Tekne hazır!', 'Pazar günü yelken açıyoruz', 'Koy çok güzel'],
	},
}
